import axios from 'axios';

const surveyTemplateApi = {
  async getSurveyTemplates() {
    const response = await axios.get('/api/surveytemplate');
    return response.data;
  },
  async getSurveyTemplate(key) {
    const response = await axios.get(`/api/surveytemplate/${key}`);
    return response.data;
  },
  async createSurveyTemplate(surveyTemplate) {
    const response = await axios.post('/api/surveytemplate', surveyTemplate);
    return response.data;
  },
  async updateSurveyTemplate(surveyTemplate) {
    const response = await axios.put(`/api/surveytemplate/${surveyTemplate.key}`, surveyTemplate);
    return response.data;
  },
  async cloneSurveyTemplate(surveyTemplate) {
    const response = await axios.post(`/api/surveytemplate/${surveyTemplate.key}/clone`, surveyTemplate);
    return response.data;
  },
  async activateSurveyTemplate(surveyTemplate) {
    const response = await axios.post(`/api/surveytemplate/${surveyTemplate.key}/activate`);
    return response.data;
  },
  async deleteSurveyTemplate(key) {
    const response = await axios.delete(`/api/surveytemplate/${key}` + key);
    return response.data;
  }

};

export default surveyTemplateApi;
